import script from "./MerchandiseInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./MerchandiseInfo.vue?vue&type=script&lang=ts&setup=true"

import "./MerchandiseInfo.vue?vue&type=style&index=0&id=8653c37a&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8653c37a"]])

export default __exports__